module.exports = require("@wildboar/x500/src/lib/modules/LdapSystemSchema/namingContexts.oa");